import React, { useState, useEffect, useRef } from 'react';import './StyleComponents/Summer2026.css'
import SATVocabFountain from './Components/SATVocabFountain'
import WritingWorkshopAnimation from './Components/WritingWorkshopAnimation';
import Contacts from './Components/Contacts';
import { 
  CalendarCheck2, CalendarCheck, Calendar, ChevronRight, 
  Globe, Globe2, School, FileEdit, Rocket, Brain, Award, 
  GraduationCap, ClipboardClock, Timer, RefreshCw, ArrowRight, 
  BarChart3, BookOpenCheck, MapPin, Compass, Bot, CalendarClock,
  Laptop, Laptop2, FlaskConical, Target, Activity, UserCheck,
  ShieldCheck, PenTool, BookOpen
} from 'lucide-react';

/**
 * Tenafly Prep Academy - Summer 2026 Programs
 * Modular React implementation with scoped class names.
 */

const TpaHero = ({onClickScroll}) => (
  <header className="tpa-summer-hero">
    <div className="tpa-summer-container tpa-summer-grid">
      <div className="tpa-summer-hero-content">
        <span className="tpa-summer-badge"><Calendar size={20} />SUMMER 2026</span>
        <h1 className="tpa-summer-h1">JULY 6<sup>th</sup> ~ AUGUST 15<sup>th</sup></h1>
        <p className="tpa-summer-p">Join Tenafly Prep Academy for an intensive summer of academic excellence, skill-building, and college readiness in a premier learning environment.</p>
        <div className="tpa-summer-cta-group">
          <button className="tpa-summer-btn-primary" onClick={()=>onClickScroll("Contact")}>REGISTER NOW</button>
        </div>
      </div>
      <div className="tpa-summer-hero-image">
        <img src="summer_university.jpg" alt="Academy Building" />
      </div>
    </div>
  </header>
);

const TpaProgramSection = ({ title, children }) => (
  <section className="tpa-summer-section" id="programs">
    <div className="tpa-summer-container">
      <h2 className="tpa-summer-section-title">{title}</h2>
      <div className="tpa-summer-section-divider"></div>
      {children}
    </div>
  </section>
);

const TpaSATVocabSection = () => (
  <div className="tpa-summer-priority-grid">
    <div className="tpa-summer-card tpa-summer-sat-card">
      {/* Header - Ensure this has the Navy Background */}
      <div className="tpa-summer-sat-header">
        <div className="tpa-summer-header-left">
          <div className="tpa-summer-icon-badge"><GraduationCap size={35} /></div>
          <h3 className="tpa-summer-h3-white">SAT BOOTCAMP</h3>
        </div>
        <div className="tpa-summer-tags">
          <span className="tpa-summer-tag-gold-solid">SAT</span>
        </div>
      </div>

      <div className="tpa-summer-card-body-clean">
        {/* Top Info Row */}
        <div className="tpa-summer-info-row">
          <div className="tpa-summer-info-column">
            <h4 className="tpa-summer-h4-navy">GROUP LESSONS</h4>
            <div className="tpa-summer-meta-left">
              <MapPin size={14} /> 
              <span>In-Person | M - Th</span>
            </div>
            <p className="tpa-summer-time-large">9:00AM - 12:00PM</p>
          </div>

          <div className="tpa-summer-vertical-divider"></div>

          <div className="tpa-summer-info-column">
            <h4 className="tpa-summer-h4-navy">FULL PRACTICE TESTS</h4>
            <div className="tpa-summer-meta-left">
              <MapPin size={14} /> 
              <span>In-Person | M - W</span>
            </div>
            <p className="tpa-summer-time-large">12:30PM - 2:30PM</p>
          </div>
        </div>

        <div className="tpa-summer-horizontal-divider"></div>
        
        {/* Bottom Virtual Box */}
        <div className="tpa-summer-virtual-box-refined">
          <div className="tpa-summer-virtual-text">
            <div className="tpa-summer-header-inline">
              <Laptop size={18} /> 
              <strong>VIRTUAL ENGLISH LESSONS</strong>
            </div>
            <p className="tpa-summer-p-sub">Concepts & Grammar (T & TH)</p>
          </div>
          <span className="tpa-summer-time-gold-accent">7:00PM - 8:30PM (Zoom)</span>
        </div>
      </div>
    </div>

    <SATVocabFountain/>
  </div>
);

const TpaReadingWorkshop = () => (
  <div className="tpa-summer-workshop-grid">
    <div className="tpa-summer-card tpa-summer-workshop-card">
      
      {/* Header matching the Navy SAT Header style */}
      <div className="tpa-summer-workshop-header">
        <div className="tpa-summer-header-left">
          <div className="tpa-summer-icon-badge">
            <FileEdit size={24} />
          </div>
          <h3 className="tpa-summer-h3-white">
            GARY WHITEHEAD'S READING & WRITING WORKSHOP
          </h3>
        </div>
      </div>

      {/* Main Body with Clean Spacing & Content Typography */}
      <div className="tpa-summer-card-body-clean">
        <p className="tpa-summer-workshop-description">
          An intensive 6-week curriculum designed to elevate literary analysis and composition skills through classical and contemporary texts.
        </p>
        
        {/* Row matching the double column layout of Group Lessons */}
        <div className="tpa-summer-info-row tpa-summer-mt-4">
          <div className="tpa-summer-info-column-clean">
            <h4 className="tpa-summer-h4-navy">UPPER LEVEL (9/10<sup>th</sup> GRADE)</h4>
            <p className="tpa-summer-time-large">9:00AM - 10:30AM</p>
          </div>

          <div className="tpa-summer-vertical-divider-workshop"></div>

          <div className="tpa-summer-info-column-clean">
            <h4 className="tpa-summer-h4-navy">LOWER LEVEL (7/8<sup>th</sup> GRADE)</h4>
            <p className="tpa-summer-time-large">10:35AM - 12:05PM</p>
          </div>
        </div>

        <div className="tpa-summer-horizontal-divider"></div>
        
        {/* Footer info box adapted cleanly like the Virtual box strip */}
        <div className="tpa-summer-schedule-box">
          <div className="tpa-summer-header-inline">
            <Calendar size={18} /> 
            <strong>WEEKLY SCHEDULE</strong>
          </div>
          <span className="tpa-summer-time-gold-accent">Monday, Tuesday, Thursday</span>
        </div>
      </div>
    </div>

    {/* Accompanying Editorial Grid Image Block */}
    <div className="tpa-summer-workshop-image">
      <WritingWorkshopAnimation/>
    </div>
  </div>
);

const TpaACTSection = () => (
  <div className="tpa-summer-card tpa-summer-act-card">
    
    {/* 1. Header Band - Navy block matching SAT Bootcamp & Workshop */}
    <div className="tpa-summer-act-header">
      <div className="tpa-summer-header-left">
        <div className="tpa-summer-icon-badge">
          <Target size={24} />
        </div>
        <h3 className="tpa-summer-h3-white">ACT LESSONS</h3>
      </div>
      <div className="tpa-summer-tags">
        <span className="tpa-summer-tag-gold-solid">ACT</span>
      </div>
    </div>

    {/* 2. Inner Split Content Grid */}
    <div className="tpa-summer-act-body-split">
      
      {/* Left Column: Description */}
      <div className="tpa-summer-act-description-side">
        <p className="tpa-summer-act-p">
          Tailored strategies and extensive practice sessions designed for students seeking a competitive edge on the ACT exam.
        </p>
      </div>

      {/* Middle Custom Content Separator Divider */}
      <div className="tpa-summer-vertical-divider-act"></div>

      {/* Right Column: Metric Stats Blocks */}
      <div className="tpa-summer-card-stats-refined">
        
        {/* Metric 1 */}
        <div className="tpa-summer-stat-item">
          <div className="tpa-summer-stat-icon-wrapper">
            <Activity size={20} />
          </div>
          <div className="tpa-summer-stat-text">
            <strong className="tpa-summer-stat-number">18</strong>
            <span className="tpa-summer-stat-label">PRACTICE TESTS</span>
          </div>
        </div>

        {/* Metric 2 */}
        <div className="tpa-summer-stat-item">
          <div className="tpa-summer-stat-icon-wrapper">
            <UserCheck size={20} />
          </div>
          <div className="tpa-summer-stat-text">
            <strong className="tpa-summer-stat-number">10</strong>
            <span className="tpa-summer-stat-label">PRIVATE LESSONS</span>
          </div>
        </div>

      </div>
    </div>

  </div>
);

const TpaPreviewLessons = () => {
  const subjects = [
    "Algebra 2", "Chemistry", "Geometry", 
    "Physics", "Precalculus", "Biology", "AP Calculus AB/BC"
  ];

  return (
    <div className="tpa-summer-card tpa-summer-preview-card">
      
      {/* 1. Brand Navy Header Strip */}
      <div className="tpa-summer-preview-header">
        <div className="tpa-summer-header-left">
          <div className="tpa-summer-icon-badge">
            <FlaskConical size={24} />
          </div>
          <h3 className="tpa-summer-h3-white">PREVIEW LESSONS</h3>
        </div>
        <div className="tpa-summer-tags">
          <span className="tpa-summer-tag-gold-solid">HEAD START</span>
        </div>
      </div>

      {/* 2. Split Body Panel */}
      <div className="tpa-summer-preview-body-split">
        
        {/* Left Column: Context Info Block */}
        <div className="tpa-summer-preview-info-side">
          <p className="tpa-summer-preview-p">
            Get ahead of the upcoming school year with rigorous, comprehensive previews of core academic subjects led by expert instructors. Build conceptual confidence before day one.
          </p>
        </div>

        {/* Center Structural Vertical Line Divider */}
        <div className="tpa-summer-vertical-divider-preview"></div>

        {/* Right Column: Academic Subjects Interactive Tag Grid */}
        <div className="tpa-summer-subject-grid-wrapper">
          <ul className="tpa-summer-subject-pill-grid">
            {subjects.map((subject, index) => (
              <li key={index} className="tpa-summer-subject-pill">
                <GraduationCap size={14} className="tpa-summer-pill-icon" />
                <span>{subject}</span>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  );
};

const TpaSecondaryPrograms = () => (
  <div className="tpa-summer-grid-2">
    
    {/* CARD 1: Special Math Programs */}
    <div className="tpa-summer-card tpa-summer-stem-card">
      <div className="tpa-summer-stem-header">
        <div className="tpa-summer-header-left">
          <div className="tpa-summer-icon-badge">
            <Compass size={24} />
          </div>
          <h3 className="tpa-summer-h3-white">SPECIAL PROGRAMS</h3>
        </div>
        <div className="tpa-summer-tags">
          <span className="tpa-summer-tag-gold-solid">COMPETITION</span>
        </div>
      </div>

      <div className="tpa-summer-card-body-clean flex-body">
        <h4 className="tpa-summer-h4-navy tpa-margin-b-sm">ENHANCED PROBLEM SOLVING</h4>
        
        <div className="tpa-summer-stem-list">          
          <div className="tpa-summer-stem-list-item">
            <div className="tpa-summer-bullet-point"></div>
            <p className="tpa-summer-stem-p">
              <strong className="tpa-summer-strong">Singapore & Kangaroo Math:</strong> Deep-dive logic and mathematical reasoning.
            </p>
          </div>

          <div className="tpa-summer-stem-list-item">
            <div className="tpa-summer-bullet-point"></div>
            <p className="tpa-summer-stem-p">
              <strong className="tpa-summer-strong">Olympiad Prep:</strong> Dedicated tracks for advanced problem solving for the American Mathematics Competitions (<span className="tpa-text-highlight-gold">AMC 8 & AMC 10</span>).
            </p>
          </div>
        </div>
        <div className="tpa-summer-stem-footer-badge">
          <ShieldCheck size={16} className="tpa-summer-footer-icon" />
          <span className="tpa-summer-footer-text">
            Authorized official testing center for Kangaroo Math Competitions & AMC8/10/12.
          </span>
        </div>
      </div>
    </div>

    {/* CARD 2: Robotics & Coding */}
    <div className="tpa-summer-card tpa-summer-stem-card">
      <div className="tpa-summer-stem-header">
        <div className="tpa-summer-header-left">
          <div className="tpa-summer-icon-badge">
            <Bot size={24} />
          </div>
          <h3 className="tpa-summer-h3-white">ROBOTICS & CODING</h3>
        </div>
        <div className="tpa-summer-tags">
          <span className="tpa-summer-tag-gold-solid">WRO PREP</span>
        </div>
      </div>

      <div className="tpa-summer-card-body-clean flex-body">
        <div className="tpa-summer-wro-title-block">
          <h4 className="tpa-summer-h4-navy">INNOVATION & COMPETITION</h4>
          <span className="tpa-summer-wro-badge">WORLD ROBOT OLYMPIAD</span>
        </div>
        
        <p className="tpa-summer-stem-p tpa-margin-b-md">
          Comprehensive project engineering, sensor calibration, and programmatic optimization targeting the official WRO competition parameters.
        </p>

        {/* Schedule Strip Box Blocks to perfectly counter balance the list heights on the left */}
        <div className="tpa-summer-stem-schedule-group">
          <div className="tpa-summer-stem-schedule-strip">
            <div className="tpa-summer-schedule-left">
              <CalendarClock size={16} className="tpa-summer-schedule-icon" />
              <strong>Friday: 3:00PM - 5:00PM</strong>
            </div>
            <span className="tpa-summer-schedule-tag">Middle School</span>
          </div>

          <div className="tpa-summer-stem-schedule-strip">
            <div className="tpa-summer-schedule-left">
              <CalendarClock size={16} className="tpa-summer-schedule-icon" />
              <strong>Saturday: 3:00PM - 5:00PM</strong>
            </div>
            <span className="tpa-summer-schedule-tag">High School</span>
          </div>
        </div>
      </div>
    </div>

  </div>
);

const TpaAPReadiness = () => (
  <div className="tpa-summer-card tpa-summer-readiness-card">
    
    {/* 1. Full-Width Brand Navy Header Strip */}
    <div className="tpa-summer-readiness-header">
      <div className="tpa-summer-header-left">
        <div className="tpa-summer-icon-badge">
          <GraduationCap size={24} />
        </div>
        <div className="tpa-summer-header-titles">
          <h3 className="tpa-summer-h3-white">AP & COLLEGE READINESS</h3>
          <p className="tpa-summer-header-subtitle">PREPARING TOMORROW'S LEADERS</p>
        </div>
      </div>
      <div className="tpa-summer-tags">
        <span className="tpa-summer-tag-gold-solid">ADVANCED TRACK</span>
      </div>
    </div>

    {/* 2. Side-by-Side Split Body Container */}
    <div className="tpa-summer-readiness-split-body">
      
      {/* Track 1: AP Humanities Preparation */}
      <div className="tpa-summer-readiness-track-box">
        <div className="tpa-summer-track-top">
          <div className="tpa-summer-track-icon-ring">
            <BookOpen size={22} />
          </div>
          <div className="tpa-summer-track-heading">
            <span className="tpa-summer-track-tag">ACADEMIC EXCELLENCE</span>
            <h4 className="tpa-summer-h4-navy">AP Language & AP US History (APUSH)</h4>
          </div>
        </div>
        <p className="tpa-summer-readiness-p">
          Integrated critical reading, rhetorical analysis, and historical data synthesis. Build core exam mechanics and content command before advanced courses begin.
        </p>
      </div>

      {/* Structural Vertical Divider (Visible on desktop) */}
      <div className="tpa-summer-readiness-center-divider"></div>

      {/* Track 2: College Essay Admissions Workshop */}
      <div className="tpa-summer-readiness-track-box">
        <div className="tpa-summer-track-top">
          <div className="tpa-summer-track-icon-ring">
            <PenTool size={22} />
          </div>
          <div className="tpa-summer-track-heading">
            <span className="tpa-summer-track-tag">ADMISSIONS INTENSIVE</span>
            <h4 className="tpa-summer-h4-navy">College Essay Workshop</h4>
          </div>
        </div>
        <p className="tpa-summer-readiness-p">
          Learn the multi-dimensional Art of the Personal Narrative. Deconstruct prompts and craft authentic drafts that resonate with admissions boards.
        </p>

        {/* Specialized Schedule Strip Anchor */}
        <div className="tpa-summer-readiness-schedule-bar">
          <Calendar size={15} className="tpa-summer-readiness-schedule-icon" />
          <div className="tpa-summer-schedule-details">
            <strong>August 26th, 27th, 28th</strong>
            <span>10:00AM - 11:30AM</span>
          </div>
        </div>
      </div>

    </div>

  </div>
);

export default function TpaSummerPage() {
  const contactRef = useRef()
  useEffect(()=>{   
      const options = {
          rootMargin: '0px',
          threshold: 0.1
      }

      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
          if (entry.isIntersecting) {
              entry.target.classList.add('visible')
          }
          })
      }, options)

      const hiddenElements = document.querySelectorAll('.contacts-container')
      hiddenElements.forEach((element)=>observer.observe(element))

      return () => {
          observer.disconnect()
      }
  },[])

  const scrollTo = (to) => {
    var reference = null
    if (to === "Contact") reference = contactRef
    const position = reference.current.getBoundingClientRect().top + window.pageYOffset - parseFloat(getComputedStyle(document.documentElement).fontSize)*2.1
    window.scrollTo({top: position, behavior: "smooth"})
  }

  return (
    <div className="tpa-summer-app">
      <TpaHero onClickScroll={scrollTo}/>
      <TpaProgramSection title="Academic Programs">
        <TpaSATVocabSection />
        <TpaReadingWorkshop />
        <TpaACTSection />
        <TpaPreviewLessons />
        <TpaSecondaryPrograms />
        <TpaAPReadiness />
      </TpaProgramSection>
      <div ref={contactRef}><Contacts/></div>
    </div>
  );
}
